import { isNull, omitBy, startCase } from 'lodash/fp';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { MediumHeaderContainer } from 'dashboard/apps/InquiryTemplateEditor/InquiryPreview/shared';
import { GovernmentIdExtractions } from 'dashboard/models/simulate/stubs';
import { Label } from 'design-system/components/Text';

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

interface GovernmentIdDetailsTableProps {
  extractionStubs: GovernmentIdExtractions;
  rightElement?: ReactNode;
}

export const GovernmentIdDetailsTable = ({
  extractionStubs,
  rightElement,
}: GovernmentIdDetailsTableProps) => {
  return (
    <>
      <MediumHeaderContainer>
        ID Details
        {rightElement}
      </MediumHeaderContainer>
      <StyledGrid>
        <>
          {Object.entries(omitBy(isNull, extractionStubs)).map(([key, value]) => (
            <>
              <Label color='secondary'>{startCase(key)}</Label>
              <div>{value}</div>
            </>
          ))}
        </>
      </StyledGrid>
    </>
  );
};
